import React from 'react';
import { AdminTab } from './adminNavigation';

type AdminTopTabsProps = {
  activeTab: AdminTab;
  onSelectTab: (tab: AdminTab) => void;
  tabCounts: {
    spots: number;
    suggestions: number;
    pending: number;
    routes: number;
    testers: number;
  };
  hasUnreadTesterThreads: boolean;
};

const tabClass = (isActive: boolean, activeColorClass: string) =>
  `text-3xs font-black uppercase tracking-[0.2em] transition-all pb-3 whitespace-nowrap ${isActive ? `text-[var(--text-primary)] border-b-2 ${activeColorClass}` : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)] border-b-2 border-transparent'}`;

const AdminTopTabs: React.FC<AdminTopTabsProps> = ({ activeTab, onSelectTab, tabCounts, hasUnreadTesterThreads }) => {
  return (
    <div className="px-8 pb-0 overflow-x-auto no-scrollbar">
      <div className="flex gap-6 border-b border-[var(--border-primary)]">
        <button onClick={() => onSelectTab('spots')} className={tabClass(activeTab === 'spots', 'border-red-500')}>
          Rapporter ({tabCounts.spots})
        </button>
        <button onClick={() => onSelectTab('suggestions')} className={tabClass(activeTab === 'suggestions', 'border-emerald-500')}>
          Endringer ({tabCounts.suggestions})
        </button>
        <button onClick={() => onSelectTab('pending')} className={tabClass(activeTab === 'pending', 'border-amber-500')}>
          Rute-forslag ({tabCounts.pending})
        </button>
        <button onClick={() => onSelectTab('routes')} className={tabClass(activeTab === 'routes', 'border-blue-500')}>
          Publisert ({tabCounts.routes})
        </button>
        <button onClick={() => onSelectTab('tools')} className={tabClass(activeTab === 'tools', 'border-purple-500')}>
          Verktøy
        </button>
        <button onClick={() => onSelectTab('ai')} className={tabClass(activeTab === 'ai', 'border-orange-500')}>
          AI-Konfig
        </button>
        <button
          onClick={() => onSelectTab('testers')}
          className={`${tabClass(activeTab === 'testers', 'border-pink-500')} flex items-center gap-1.5`}
        >
          Testere ({tabCounts.testers})
          {hasUnreadTesterThreads && <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />}
        </button>
        <button onClick={() => onSelectTab('privacy')} className={tabClass(activeTab === 'privacy', 'border-emerald-400')}>
          Vilkår
        </button>
      </div>
    </div>
  );
};

export default AdminTopTabs;
